"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = "\n  .screenReader-only {\n    position: absolute;\n    left: -9999999999px;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  }\n";
exports["default"] = _default;